import { useTranslation } from 'react-i18next';
import { PyThreadAuthorLabel } from './styled';
import { useUserContext } from 'providers/UserProvider';
import { useViewerInfo } from 'components/preview/identify-viewer/useViewerInfo';
import { isValidEmail } from 'utils/isValidEmail';

export const ThreadPrivateAuthor = () => {
  const { t } = useTranslation();
  const { data } = useUserContext();

  const getAuthor = () => {
    return data?.fullName || t('comments.anonymous');
  };

  return <PyThreadAuthorLabel>{getAuthor()}</PyThreadAuthorLabel>;
};

export const ThreadPublicAuthor = () => {
  const { t } = useTranslation();
  const { viewer, clearViewerEmail } = useViewerInfo();

  const getAuthor = () => {
    if (viewer?.email && isValidEmail(viewer.email)) {
      return viewer.email;
    }

    clearViewerEmail();
    return t('comments.anonymous');
  };

  return <PyThreadAuthorLabel>{getAuthor()}</PyThreadAuthorLabel>;
};
